import { Input, InputProps } from 'antd'
import React, { useEffect, useState } from 'react'

type Props = Omit<InputProps, 'onChange'> & {
  onChange?: (value: string) => void
}

export const BlurryInput: React.FC<Props> = ({
  id,
  value,
  onChange,
  ...props
}) => {
  const [valueLocal, setValueLocal] = useState('')

  useEffect(() => {
    if (value !== valueLocal) {
      setValueLocal(value as string)
    }
  }, [value])

  const handleChange = (valueUpdated: string) => {
    onChange?.(valueUpdated)
  }

  return (
    <span id={id}>
      <Input
        value={valueLocal}
        onChange={event => setValueLocal(event.target.value)}
        onBlur={event => handleChange?.(event.target.value)}
        {...props}
      />
    </span>
  )
}
